<template>
  <main class="main" id="main">
    <franchiseNav></franchiseNav>
    <div class="top_line">
      <div class="container">
        <h1>Инвестировать в открытие</h1>
      </div>
    </div>

    <section class="section s-join_form">
      <div class="container">
        <div class="restaurant_form">
          <div class="main_form_box">
            <div class="form_title">
              <h1>ОСТАВЬТЕ ЗАЯВКУ НА УЧАСТИЕ В ИНВЕСТИЦИОННОЙ ПРОГРАММЕ</h1>
              <p>Срок рассмотрения заявок - до 3-х дней</p>
            </div>

            <div class="input_order">
              <input type="text" name="" class="order" v-model="name" required>
              <div class="placeholder">
                Ваше имя <span>*</span>
              </div>
            </div>

            <div class="input_order">
              <input type="text" name="" class="order" v-model="city.name" required>

              <div class="placeholder">
                Город <span>*</span>
              </div>
            </div>

            <div class="input_order">
              <input type="text" name="" class="order" v-model="phone" data-inputmask="'mask': '+9(999)999-99-99'" required>

              <div class="placeholder">
                +7(__)__-__-__ <span>*</span>
              </div>
            </div>

            <div class="input_order">
              <input type="text" name="" class="order" v-model="email"  required>

              <div class="placeholder">
                user@domain.com <span>*</span>
              </div>
            </div>

          </div>

          <div class="info_agreement">
            <input type="checkbox" name="" id="post" v-model="checkbox">
            <label for="post" id="info_label"></label>
            Я принимаю <span class="link">условия пользовательского соглашения</span>
          </div>

          <button class="menu_item_btn" @click="sendOffer">УЗНАТЬ КАК</button>
        </div>

      </div>
    </section>
    <section class="section s-seo">
      <div class="container">
        <div class="seo_box">
          <div class="bottom-wrapper">
            <div class="line"></div>
            <div class="main-image-investment franchise__main-image" style="margin-top: 3%;">
              <div class="main-image-image investment-img"></div>
              <div class="franchise__container">
                <div class="investment__two-lists-wrapper">
                  <p class="investment__list-text">Вы хотите инвестировать в открытие агрегатора Хочу Поесть / When Hungry в каком-либо городе или стране, но не хотите участвовать в оперативном управлении?</p>
                  <div class="investment__icons-title-wrapper">
                    <h2 style="font-weight: 300;"> Все управление мы возьмем на себя!</h2>
                  </div>
                </div>
                <div class="invest__top-icons-wrapper">
                  <div class="investment__icons-title-wrapper">
                    <h3 style="font-weight: 300;">КАК ЭТО ПРОИСХОДИТ:</h3>
                  </div>
                  <div class="franchise__icons-list-wrapper">
                    <ol class="franchise__icons-list">
                      <li class="franchise__icons-list-item">
                        <div class="franchise__item-left">
                          <div class="franchise__item-icon investment__item-icon-map"></div>
                          <p class="franchise__item-text">вместе с Вами мы определяем город или страну</p>
                        </div>
                      </li>
                      <li class="franchise__icons-list-item">
                        <div class="franchise__item-left">
                          <div class="franchise__item-icon franchise__item-icon-doc"></div>
                          <p class="franchise__item-text">заключаем инвестиционный договор с передачей Вам соответствующих прав</p>
                        </div>
                      </li>
                      <li class="franchise__icons-list-item">
                        <div class="franchise__item-left">
                          <div class="franchise__item-icon investment__item-icon-key"></div>
                          <p class="franchise__item-text">наши специалисты открывают город или страну и осуществляют оперативное управление бизнесом</p>
                        </div>
                      </li>
                      <li class="franchise__icons-list-item">
                        <div class="franchise__item-left">
                          <div class="franchise__item-icon investment__item-icon-rating">
                          </div>
                          <p class="franchise__item-text">прибыль от деятельности распределяется следующим образом: на дальнейшее развитие, выплата инвестору, выплата команде</p>
                        </div>
                      </li>
                    </ol>
                    <p>Напишите нам <a href="mailto:sev@hochu-poest.com">sev@hochu-poest.com</a></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="smi_about_us">
      <div class="title_box">
        <h2>Напишите нам sev@hochu-poest.com</h2>
        <h1>СМИ О НАС</h1>
      </div>
      <div class="smi_carousel">
        <a href="https://www.the-village.ru/talks/business/58851-onlayn-agregator-dostavki-edy-istoriya-razvitiya" class="slick-slide" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi1.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://rfranch.ru/hochu_poest/" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi2.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://zhazhda.biz/cases/hochu-poest" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi3.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://bi-school.ru/kak-razvivat-svoj-biznes-putem-rasprostraneniya-franshizy/" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi4.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://promdevelop.ru/chto-vliyaet-na-pribyl-franshizy-sovety-dlya-franchajzi/" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi5.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://www.biz-club.ru/releases/missiya-nauchit-rossiyu-ekonomit-vremya-i-dengi-na-ede/" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi6.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://p-release.ru/dosug-turizm-i-otdyh/procent-golodayushchih-po-nocham-vyros-na-21" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi7.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://professionali.ru/Soobschestva/na_rabotu_v_svoj_biznes/istorija-razvitija-onlajn-agregatora/" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi8.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://multimillionaire.money/articles/4682/" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi9.png" />
        </a>
        <a class="slick-slide" tag="div" href="https://www.kom-dir.ru/question/105-strategiyu-razvitiya-malogo-biznesa" target="_blank">
          <img src="https://xn----jtbzbeohcqv6d.xn--p1ai/static/img/for_restaurants/smi10.png" />
        </a>
      </div>
    </div>
  </main>
</template>

<script>
import franchiseNav from '@/components/franchiseNav'
import axios from '@/router/http'
import Inputmask from 'inputmask'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel'
export default {
  props: ['city', 'auth', 'geo', 'user'],
  name: 'investment',
  components: {franchiseNav},
  data () {
    return {
      checkbox: null,
      name: null,
      phone: null,
      email: null
    }
  },
  created () {
    Inputmask().remove(document.getElementById('input'))
    setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
    $('.smi_carousel').slick({
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 200,
      swipeToSlide: true,
      speed: 500,
      slidesToShow: 9,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            autoplaySpeed: 400
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            autoplaySpeed: 400
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            autoplaySpeed: 400
          }
        }
      ]
    })
  },
  methods: {
    sendOffer () {
      this.errors = []
      if (!this.name) alert('Необходимо указать имя')
      else if (!this.phone) alert('Необходимо указать телефон')
      else if (!this.email) alert('Необходимо указать почту')
      else if (!this.checkbox) alert('Вам необходимо принять пользовательское соглашение')
      else {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        formData.append('crm', '7')
        formData.append('pipe', '13')
        formData.append('lead[102]', 'Хочу Поесть + Россия (ru)')
        formData.append('lead[103]', this.city.name)
        formData.append('note', 'Заявка на инвестиции')
        formData.append('contact[name]', this.name)
        formData.append('contact[100]', this.phone)
        formData.append('contact[101]', this.email)
        formData.append('contact[106]', this.city.name)
        formData.append('contact[107]', 'Хочу Поесть + Россия (ru)')
        axios.post('https://franch.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    }
  }
}
</script>

<style scoped>
  .franchise__icons-list {
    padding-left: 25px;
  }
  .franchise__icons-list-item {
    padding: 5px 0;
  }
</style>



// WEBPACK FOOTER //
// src/articles/investment.vue